module.exports = __webpack_public_path__ + "img/c6ad363.svg";